// extracted by mini-css-extract-plugin
export default {"ConfirmMergeContainer":"ConfirmMerge-module__ConfirmMergeContainer__qIxQhcb","ConfirmMergeText":"ConfirmMerge-module__ConfirmMergeText__LjWK7kB"};